import { render, staticRenderFns } from "./DataConfigurationSection.vue?vue&type=template&id=701775a9&scoped=true"
import script from "./DataConfigurationSection.vue?vue&type=script&lang=js"
export * from "./DataConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701775a9",
  null
  
)

export default component.exports